import { PhotoshopController } from "../photoshopController.js";
import { ImageWidget } from "../UI/widget/imageWidget.js";
import { LayerWidget } from "../UI/widget/filters/layerWidget.js";

export class LayersWidget {
    parentElement: HTMLElement;
    photoshopController: PhotoshopController;
    widgetList: any[];
    constructor(parentElement: HTMLElement, controller: PhotoshopController) {
        this.parentElement = parentElement;
        this.photoshopController = controller;
        this.widgetList = [];
    }

    static html() {
        return `
        <div id="photoshop-layers" class="col s12" style="overflow-y: auto;">
        </div>
        `;
    }

    resize(_event?) {
        var layersElement = document.getElementById('photoshop-layers');
        if (layersElement && layersElement.offsetParent) {
            layersElement.style.height = ((layersElement.offsetParent as HTMLElement).clientHeight - layersElement.offsetTop).toString() + 'px';
        }
    }

    refreshLayers() {
        const photoshopLayers = document.getElementById("photoshop-layers");
        if (!photoshopLayers) {
            return;
        }
        if (!this.photoshopController.PSEngine) {
            return;
        }

        photoshopLayers.innerHTML = "";

        const h4 = document.createElement("h4");
        h4.innerText = "Calques";
        photoshopLayers.appendChild(h4);
        this.widgetList = [];

        const layers = this.photoshopController.PSEngine.layers;

        for (let i = layers.length - 1; i >= 0; i--) {
            const layer = layers[i];
            const operations = layer.operations;

            for (let j = operations.length - 1; j >= 0; j--) {
                const operation = operations[j];
                this.widgetList.push(new LayerWidget(photoshopLayers, layer, this.photoshopController.PSEngine, this.photoshopController.PSCamera, operation, this.photoshopController));
            }
            this.widgetList.push(new ImageWidget(photoshopLayers, layer, this.photoshopController.PSEngine, this.photoshopController.PSCamera, null, this.photoshopController));
        }
    }

    updateClass() {
        this.widgetList.forEach(widget => {
            widget.updateClass();
        });
    }
}